import React, { useEffect, useState } from "react";
import CustomSelectBox from "../CustomSelectBox/CustomSelectBox";

import "./table.css";

const Table = (props) => {
  const [limit, setLimit] = useState(props.limit);
  const [range, setrange] = useState([]);
  const [pages, setpages] = useState(1);

  const [dataShow, setDataShow] = useState([]);
  const [currPage, setCurrPage] = useState(0);

  const selectPage = (page) => {
    const start = Number(limit) * page;
    const end = start + Number(limit);

    setDataShow(props.bodyData.slice(start, end));

    setCurrPage(page);
  };
  //component render
  useEffect(() => {
    console.log("table component rendering");
  });

  //component did update
  useEffect(() => {
    console.log("table component did updating for LIMIT state", limit);
  }, [limit]);

  //component did mount
  useEffect(() => {
    console.log("table component did mount");
  }, []);
  //component will un mount
  useEffect(() => {
    return () => {
      console.log("component will unmount");
    };
  }, []);

  useEffect(() => {
    let initDataShow =
      limit &&
      props.bodyData &&
      props.bodyData !== undefined &&
      props.bodyData.length >= Number(limit)
        ? props.bodyData?.slice(0, Number(limit))
        : props.bodyData;

    setDataShow(initDataShow);

    return () => {
      initDataShow = [];
    };
  }, [limit, props.bodyData]);

  useEffect(() => {
    if (
      limit !== undefined &&
      dataShow !== undefined &&
      dataShow.length >= Number(limit)
    ) {
      let page = Math.floor(props.bodyData.length / Number(limit));
      let render_pages =
        props.bodyData.length % Number(limit) === 0 ? page : page + 1;
      setpages(render_pages);
      setrange([...Array(pages).keys()]);
    }

    return () => {};
  }, [dataShow, limit, pages, props.bodyData.length]);

  const limitChanged = (_limit) => {
    let ReinitDataShow =
      _limit &&
      props.bodyData &&
      props.bodyData !== undefined &&
      props.bodyData.length >= Number(_limit)
        ? props.bodyData?.slice(0, Number(_limit))
        : props.bodyData;
    setDataShow(ReinitDataShow);
    setCurrPage(0);
    setLimit(_limit);
    if (
      _limit !== undefined &&
      dataShow !== undefined &&
      dataShow.length >= Number(_limit)
    ) {
      let page = Math.floor(props.bodyData.length / Number(_limit));
      let render_pages =
        props.bodyData.length % Number(_limit) === 0 ? page : page + 1;
      setpages(render_pages);
      setrange([...Array(pages).keys()]);
      console.log("render_pages", render_pages);
      console.log("range", [...Array(pages).keys()]);
    } else {
      setpages(1);
      setrange([]);
    }
    // console.log("pages", pages);
    // console.log("range", range);
  };

  return (
    <div>
      <div id={props.id} className="flex flex-col w-full">
        <div className="flex my-4 justify-between">
          {/* search count */}
          <div className="flex">
           {
            props?.showSearch && ( <div className="p-5 flex justify-center items-center font-extrabold text-sm bg-green-600 text-white rounded">
            Search count : {props.bodyData.length}
          </div>)
           }
          </div>

          {/* Display select box */}
          {
            props?.showLimit &&  (
            <div className="flex items-center">
            <div className="px-2 mb-4 text-white">Display</div>

            <CustomSelectBox
              className=""
              items={[5, 10, 50, 100, 200]}
              onChange={(e) => {
                limitChanged(e.target.value);
              }}
              name="limit"
              value={limit}
            />
          </div>)
          }
        </div>
        {/* {props?.showLimit && (
          <div className="flex w-full justify-between items-center overflow-x-hidden">
            <div className="flex m-2"></div>
            <div className="flex justify-center items-center"></div>
          </div>
        )} */}
        <div className="table-wrapper">
          <table  className={"tbl_body "+props?.tableStyle} >
            {props.headData && props.renderHead ? (
              <thead {...props?.tableHeaderStyle}>
                <tr key={"tbl-head"}>
                  {props.headData.map((item, index) =>
                    props.renderHead(item, index)
                  )}
                </tr>
              </thead>
            ) : null}
            <tbody>
              {dataShow && props.bodyData ? (
                dataShow && dataShow.length !== 0 ? (
                  dataShow.map((item, index) => props.renderBody(item, index))
                ) : (
                  <tr  key={"0001"} style={{ width: "100%" }}>
                    <td colSpan={19}>sorry, there is no data available</td>
                  </tr>
                )
              ) : (
                <tr key={"error1111"}>
                  <td>sorry, there is no data available {dataShow.length}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* {range.length}
      {pages} */}
      {pages > 1 ? (
        <div className="table__pagination">
          {range.map((item, index) => (
            <div
              key={index}
              className={`table__pagination-item ${
                currPage === index ? "active" : ""
              }`}
              onClick={() => selectPage(index)}
            >
              {item + 1}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default Table;
